/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Group_YearInputs */

const vi_warehouse_sales_group_year = /** @type {(inputs: Warehouse_Sales_Group_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Năm`)
};

/**

* @param {Warehouse_Sales_Group_YearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_group_year = /** @type {((inputs?: Warehouse_Sales_Group_YearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Group_YearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_group_year(inputs)
});